export const SUNGSU_TILESET_ADJUST_HEIGHT = -35;

export default { SUNGSU_TILESET_ADJUST_HEIGHT };
